// extracted by mini-css-extract-plugin
module.exports = {"countdownRow":"CountdownBar_countdownRow__4qCmO","text":"CountdownBar_text__1QJCm","countdown":"CountdownBar_countdown__2dk_2"};